var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":"","my-1":"","pt-4":"","mt-5":""}},[_c('groups-search-panel')],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","my-1":""}},[_c('groups-panel')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56990542","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Groups/GroupsIndex.vue
// module id = null
// module chunks = 